import axios from "lib/axios";

export const deleteDocumentApi = async ({ building_id, id }) => {
  return await axios.delete(`/minutes/buildings/${building_id}/documents/${id}`);
};
